<template lang="pug">
div.pa-2
  v-row.pa-0.ma-0
    h2.mt-2 Типовые вопросы:
    v-spacer
    v-btn(icon fab color="primary" @click="toggleFilter = !toggleFilter")
      v-icon mdi-filter
  v-expand-transition
    v-card(v-if="toggleFilter")
      v-card-text
        v-text-field(
          v-model="search.name"
          label="Название вопроса"
          filled
          hide-details
        )
        v-select.mt-2(
          v-model="search.project"
          filled
          multiple
          label="Выберите проекты"
          :items="projects"
          item-text="name"
          item-value="id"
          hide-details
        )
        autocomplete-key-words.mt-2(
          v-model="search.tag"
        )
        //- v-autocomplete.mt-2(
        //-   v-model="search.tag"
        //-   filled
        //-   multiple
        //-   hide-details
        //-   label="Тэги"
        //-   :items="keyWords"
        //-   item-text="name"
        //-   item-value="id"
        //- )
      v-card-actions
        v-btn(@click="getHints" large color="primary") Поиск
        v-btn(@click="reset" large) Сбросить

  v-btn.mt-2(color="primary" @click="dialog = true") Добавить типовой вопрос

  v-alert.mt-2(type="info" v-if="!hints.length") Еще нет типовых вопросов
  v-list(v-else three-line)
    hint-item(
      v-for="hint in hints" :key="hint.id"
      :hint="hint"
      :keyWords="keyWords"
      :projects="projects"
      @editHint="editHint"
      @update="getHints"
    )
    v-pagination(
      v-if="pagination.length > 1"
      color="info"
      v-model="pagination.current"
      :length="pagination.length"
      :total-visible="7"
      @input="getHints"
    )

  v-dialog(v-model="dialog" max-width="900")
    v-card(dark)
      v-card-title {{payload.id ? 'Редактирование' : 'Создание'}} типового вопроса
      v-card-text
        v-text-field(
          v-model="payload.title"
          label="Введите вопрос"
        )
        v-checkbox(v-model="checkbox" label="Форматированный текст")
        app-editor.white(v-if="checkbox" v-model="payload.text" filled)
        v-textarea(
          v-else
          v-model="payload.text"
          label="Введите ответ"
        )
      v-card-actions
        v-btn(color="error" @click="resetDialogs") Отмена
        v-spacer
        v-btn(color="success" @click="createHint") Сохранить
</template>
<script>
import AppEditor from '@/components/AppEditor.vue';
import autoAnswerService from '@/services/API/autoAnswer';
import { CRUDProjects } from '@/services/API/project';
import HintItem from './HintItem.vue';
import autocompleteKeyWords from './autocompleteKeyWords.vue';

export default {
  name: 'AutoAnsewerSettings',
  components: {
    HintItem,
    AppEditor,
    autocompleteKeyWords,
  },
  props: {
    keyWords: { type: Array, default: () => [] },
  },
  data() {
    return {
      checkbox: false,
      search: {},
      toggleFilter: false,
      pagination: {
        length: 1,
        current: 1,
      },
      hints: [],
      projects: [],
      dialog: false,
      payload: {
        title: '',
        text: '',
      },
    };
  },
  computed: {
    serilizeKeyWords() {
      return this.keyWords.map((item) => {
        const result = { ...item, require: false };
        delete result.open;
        return result;
      });
    },
  },
  async created() {
    this.getHints();
    this.getProjects();
  },
  methods: {
    editHint(hint) {
      this.payload = hint;
      this.dialog = true;
    },
    reset() {
      this.search = {};
      this.getHints();
    },
    resetDialogs() {
      this.dialog = false;
      this.payload = {
        title: '',
        text: '',
      };
    },
    async getHints() {
      const search = {
        'search[title]': this.search.name,
        'search[project_id]': this.search.project,
        'search[tag_id]': this.search.tag,
        'page': this.pagination.current,
      };
      try {
        const response = await autoAnswerService.getHints({ ...search, expand: 'projects,require_tags,not_require_tags' });
        this.pagination.length = +response.headers['x-pagination-page-count'];
        this.hints = response.data.data;
      } catch (e) {
        this.$toast.error(e.response.data.result_message);
      }
    },
    async createHint() {
      try {
        const { id } = this.payload;
        const method = id ? 'updateHint' : 'createHint';
        const response = await autoAnswerService[method](this.payload);
        this.hints.push(response.data.data);
        this.$toast.success(id ? 'Успешно обналена' : 'Успешно создана');
      } catch (e) {
        this.$toast.error(e.response.data.result_message);
      }
      this.resetDialogs();
    },
    async getProjects() {
      await CRUDProjects.getAll().then((response) => {
        this.projects = response.data.data;
      });
    },
  },
};
</script>
